var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236,
    height: 181.68,
    viewBox: "0 0 236 181.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 143.075,
    height: 143.126,
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9e17",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e17",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_52",
    "data-name": "Groupe 52",
    transform: "translate(-69 -315.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_49",
    "data-name": "Groupe 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_48",
    "data-name": "Groupe 48",
    transform: "translate(117 335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_47",
    "data-name": "Groupe 47",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M178.792,89.446v.032l.032,0Z",
    transform: "translate(-129.305 -64.689)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M201.3,157.3c1.229.068,2.464.017,3.759.017V152.5h-4.8V142.453h4.751v-9.6h-4.809c0,1.263-.059,2.413.017,3.554.071,1.069-.376,1.341-1.374,1.317q-3.664-.087-7.333,0c-.961.021-1.335-.287-1.286-1.263.061-1.218.015-2.441.015-3.628h-4.826c0,1.344.057,2.588-.035,3.82-.027.369-.449.989-.727,1.01-1.361.105-2.735.048-4.238.048,0-1.472.045-2.756-.016-4.035-.042-.873.31-1.13,1.131-1.1,1.222.048,2.448.012,3.68.012v-4.818h-4.68v-5h4.806c0-1.254.056-2.4-.016-3.531-.068-1.054.231-1.521,1.379-1.416,1.128.1,2.272.022,3.576.022v-4.869H195.3v4.78h4.837c0-1.232.056-2.379-.017-3.518-.064-1,.222-1.437,1.3-1.359,1.193.086,2.4.02,3.6.02h4.928v-4.816c-2.443,0-4.789.013-7.135,0-3.121-.021-2.628.376-2.671-2.6-.011-.762,0-1.525,0-2.251H185.413c0,1.271-.05,2.423.016,3.569.054.95-.26,1.344-1.247,1.292-1.216-.064-2.438-.015-3.813-.015v9.8c-2.924,0-5.687-.042-8.448.022-1.059.024-1.444-.241-1.424-1.378.07-3.965.027-7.933.027-11.9v-1.488c-1.158,0-2.079,0-3,0-2.2-.009-1.957.17-1.959-1.894q0-1.937,0-3.874V93.15h4.869V88.359h-9.674c0,.6,0,1.1,0,1.6,0,2.352-.031,4.705.02,7.057.02.915-.3,1.223-1.2,1.177-1.224-.062-2.453-.015-3.836-.015v4.947h-4.92c0,1.337-.042,2.527.014,3.712.043.916-.339,1.222-1.216,1.212q-3.8-.042-7.61.008c-.848.012-1.143-.3-1.107-1.139.052-1.226.014-2.456.014-3.789h-4.745c-.032.512-.072.869-.074,1.225-.021,3.874-.02,3.874-3.917,3.727a1.1,1.1,0,0,0-.138,0c-.773.061-1.061-.3-1.058-1.066q.027-6.434,0-12.868c0-.676.205-1.029.953-1,1.059.041,2.122.036,3.182,0,.71-.022,1,.263.986.972-.026,1.281-.007,2.563-.007,4.112h4.761v4.651h9.957V98.121c1.432,0,2.675.066,3.9-.04.368-.032.992-.539,1-.834.049-4.286,0-8.572.01-12.858,0-.807-.308-1.036-1.06-1.025-2.166.03-4.334.017-6.5.008-2.616-.011-2.3.255-2.3-2.267s0-5.033,0-7.6c-1.408,0-2.608-.048-3.8.016-.936.05-1.2-.338-1.175-1.216.048-1.7.014-3.411.014-5.117,0-1.175,0-2.351,0-3.486h-4.819c0,2.723-.006,5.344,0,7.965.005,1.849.013,1.849-1.779,1.851-1.036,0-2.073,0-3.205,0V88.264h-4.869v4.854H121.21V88.264h-4.868v-5h4.876V68.609h4.948l.132-4.884-5.139-.253V53.837h-4.882c0,.639,0,1.181,0,1.723q.008,9.877.015,19.754c0,3.135,0,3.138-3.1,3.143-2.237,0-4.474,0-6.631,0-.128,1.726-.238,3.21-.348,4.692,1.664.075,3.331.152,5.072.232v4.945h-4.7v4.852c1.327,0,2.56.02,3.791-.008.668-.015,1.045.163,1.01.924-.061,1.365-.073,2.731-.1,4.1,1.187-.026,2.38.016,3.557-.1s1.492.326,1.48,1.466c-.055,5.672-.033,11.345-.045,17.018,0,.4-.058.8-.1,1.324h-9.623v4.838c.41.026.724.063,1.037.064,4.058,0,8.117-.041,12.175.022,1.172.018,1.476-.363,1.461-1.5-.064-5.026-.04-10.054-.045-15.081,0-3.24,0-3.24,3.239-3.258,1.768-.01,1.769-.01,1.771,1.819,0,2.658,0,5.317,0,8.093,1.449,0,2.734-.046,4.011.032.325.02.881.418.9.671.089,1.363.042,2.736.042,4.163-.525.046-.882.088-1.239.106-1.182.058-2.9-.339-3.411.273-.628.754-.218,2.349-.314,3.576-.068.867.283,1.132,1.119,1.092,1.227-.058,2.459-.015,3.865-.015v4.948h19.684c0,1.421-.045,2.664.015,3.9.042.86-.28,1.143-1.116,1.108-1.228-.051-2.459-.013-3.862-.013V137.7h-4.771v4.806h1.409c2.4,0,4.8-.029,7.194.029.38.009,1.057.383,1.075.626.1,1.4.051,2.817.051,4.234h-9.952v-4.763c-2.9,0-5.655-.05-8.408.024-1.131.03-1.525-.281-1.5-1.46.068-3.965.03-7.932.025-11.9,0-.482-.052-.964-.084-1.5-3.032,0-5.889-.022-8.744.03-.319.006-.9.422-.9.657-.062,2.983-.041,5.968-.041,9.09h4.957c0,1.552.025,2.968-.026,4.381a.845.845,0,0,1-.557.606c-1.449.052-2.9.028-4.435.028v-4.81H106.6v4.809h9.759v9.718l4.94.255c0,1.578,0,3.154,0,4.9h-5.015c0,1.273.077,2.379-.022,3.469s.352,1.316,1.342,1.308c5.762-.046,11.525-.035,17.287-.049.308,0,.615-.053.979-.087v-9.644c-1.326,0-2.566.042-3.8-.026-.366-.02-1.011-.335-1.024-.546-.091-1.445-.048-2.9-.048-4.356h5.086v4.891c1.1,0,2.017.01,2.929,0,1.994-.027,1.981-.032,1.971,1.908-.013,2.57,0,5.141,0,7.8h4.884v-1.4c0-2.4-.028-4.795.03-7.191.009-.38.38-1.057.622-1.075,1.4-.1,2.808-.05,4.332-.05v4.813c.476.044.834.106,1.192.106,2.3,0,4.61,0,6.914-.026,1.787-.019,1.789-.032,1.788,1.7,0,1.039,0,2.078,0,3.108h4.811c0-1.238.049-2.385-.015-3.525-.052-.927.208-1.378,1.219-1.3a17.611,17.611,0,0,0,2.626,0c1-.072,1.272.378,1.224,1.3-.061,1.172-.015,2.349-.015,3.623,1.408,0,2.6.037,3.795-.013.826-.035,1.169.24,1.131,1.1-.054,1.23-.014,2.464-.014,3.76h4.922a29.31,29.31,0,0,0-.024-3.273c-.157-1.349.411-1.621,1.639-1.608,5.485.059,10.971.034,16.457.033.528,0,1.055-.043,1.632-.068,0-1.347.045-2.5-.014-3.647-.046-.895.249-1.246,1.176-1.194M150.088,88.241a1.03,1.03,0,0,1,.719.7c.073,1.363.034,2.731.034,4.269-1.221,0-2.315.073-3.395-.02-1.175-.1-1.694.223-1.558,1.5.115,1.082.024,2.187.024,3.509h-5.017q-.063-4.923-.127-9.845c3.106-.05,6.213-.117,9.32-.118M136.034,83.3c1.441,0,2.848-.024,4.252.025.223.008.624.35.622.536-.012,1.49-.1,2.98-.165,4.472h-4.709Zm4.933,38.662a1.141,1.141,0,0,1-.74.827c-1.363.086-2.735.039-4.193.039V112.9c1.46,0,2.792-.056,4.113.042a1.235,1.235,0,0,1,.816.883c.065,2.713.061,5.429,0,8.142M126.11,152.519c-1.615,0-3.193,0-4.769,0-.076-1.624-.152-3.249-.233-4.973h5Zm24.8-34.553v4.752h-4.966V112.93h9.771c0-1.368.04-2.6-.013-3.825-.04-.9.294-1.209,1.2-1.191,2.536.049,5.074.059,7.609,0,1.032-.025,1.213.4,1.209,1.315-.014,3.753.011,3.751-3.725,3.777-.359,0-.717.049-1.111.078v9.679c-1.368.015-2.742.01-4.113.063-.8.032-1.053-.34-1.037-1.081.027-1.232.007-2.464.007-3.775Zm8.651,14.793c-.959-.073-1.936.052-2.887-.06-.346-.041-.892-.5-.914-.8-.1-1.315-.043-2.641-.043-4.126h4.808c.137-1.766.262-3.378.387-4.988h4.823c-.13,1.782-.252,3.457-.374,5.132l-4.593-.208c0,1.325-.049,2.545.016,3.758.05.931-.216,1.364-1.222,1.288m14.825,9.875c-.92-.046-1.846.032-2.764-.029-.81-.054-1.04.283-1.03,1.041.035,2.442-.02,4.887.05,7.327.032,1.1-.228,1.558-1.448,1.511-2.485-.1-4.977-.055-7.465-.011-.845.015-1.136-.279-1.125-1.115q.051-3.871,0-7.743c-.011-.837.286-1.155,1.129-1.118,1.193.051,2.391.013,3.651.013a4.082,4.082,0,0,0,.175-.809q.014-6.5,0-13a3.493,3.493,0,0,0-.172-.769c1.669-.112,3.342-.226,5.129-.347v-4.8c1.564,0,3.018-.036,4.466.042.2.011.532.582.534.895.033,5.945.012,11.89.041,17.835,0,.885-.366,1.118-1.165,1.078m20.953,13.611c.006.9-.3,1.2-1.208,1.188q-6.227-.058-12.455,0c-.936.009-1.3-.231-1.291-1.233.049-4.2.041-8.4.011-12.592-.006-.84.265-1.137,1.113-1.119,2.167.045,4.336.015,6.5.015,2.03,0,4.06.032,6.089-.014.868-.02,1.249.223,1.242,1.158q-.052,6.3,0,12.593",
    transform: "translate(-76.812 -38.936)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M32.983,391.989c-10.422.052-20.845.03-31.269.03H.157a11.875,11.875,0,0,0-.131,1.2c-.006,10.7.007,21.4-.026,32.1,0,1.071.384,1.3,1.379,1.3q15.773-.048,31.545.012c1.337.007,1.588-.445,1.583-1.661q-.063-15.7,0-31.407c.005-1.193-.277-1.569-1.526-1.563m-3.3,28.317c0,.817-.022,1.39-1.137,1.384-7.648-.036-15.3-.014-22.944-.015a5.788,5.788,0,0,1-.749-.126V420.1c0-7.233.024-14.467-.024-21.7-.007-1.139.3-1.494,1.464-1.486q10.919.072,21.838,0c1.2-.008,1.579.324,1.57,1.554-.053,7.279-.031,14.559-.017,21.838",
    transform: "translate(0 -283.494)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M321.455,86.018h4.686c.019-.433.036-.79.05-1.147.045-1.142-.345-2.764.247-3.3.686-.62,2.243-.228,3.408-.379s1.39.38,1.377,1.414c-.051,4.058-.006,8.116-.059,12.174-.013.974.293,1.3,1.263,1.262,1.658-.065,3.32-.019,4.98-.019,3.755,0,3.722,0,3.7,3.765,0,.978-.313,1.27-1.269,1.246-2.489-.061-4.98,0-7.469-.055-.885-.02-1.256.219-1.2,1.158.068,1.226.017,2.459.017,3.8h-4.711a2.621,2.621,0,0,0-.195.624c-.014,2.767,0,5.534-.029,8.3-.008.8.436.871,1.064.866,2.49-.018,4.982-.058,7.47.012,1.024.029,1.377-.249,1.343-1.309-.078-2.442-.061-4.888-.012-7.331.008-.394.355-1.1.587-1.118,1.4-.105,2.821-.053,4.417-.053v4.8h4.8c0-1.3.039-2.488-.013-3.677-.036-.826.238-1.188,1.1-1.144a17.765,17.765,0,0,0,2.9-.024,1.266,1.266,0,0,0,.9-.8c.1-1.316.043-2.644.043-4.1h-4.825V96.1h4.95v4.761h4.836c0-1.255.069-2.411-.02-3.556-.085-1.08.349-1.361,1.351-1.3,1.173.076,2.355.018,3.544.018v-4.84h-1.724q-10.514.01-21.028.02c-1.841,0-1.842,0-1.84-1.778,0-3.92-.018-7.84.035-11.759.014-1.008-.264-1.384-1.321-1.355-2.488.069-4.981-.013-7.469.04-.927.02-1.208-.308-1.161-1.2.064-1.222.016-2.45.016-3.7h-4.737Z",
    transform: "translate(-232.482 -51.679)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M34.669.329H.4V34.563H34.669ZM29.985,28.505c.006,1.136-.4,1.388-1.452,1.383q-10.989-.056-21.978.007C5.36,29.9,5.1,29.5,5.119,28.394c.062-3.639.023-7.28.023-10.92,0-3.732.028-7.465-.019-11.2-.012-.973.306-1.267,1.267-1.263q11.127.048,22.255,0c1.035,0,1.35.359,1.345,1.372q-.053,11.058,0,22.116",
    transform: "translate(-0.287 -0.238)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M425.811,34.627c1.283.006,1.27-.621,1.268-1.527q-.019-15.7-.012-31.4c0-.484-.061-.968-.1-1.482H392.694V34.512c.447.031.807.079,1.166.079,10.65,0,21.3-.019,31.95.035M397.41,6.241c0-.924.256-1.31,1.256-1.306q11.137.051,22.275,0c1.061,0,1.32.383,1.306,1.383-.051,3.689-.02,7.379-.02,11.068,0,3.735-.022,7.471.015,11.207.009.877-.228,1.214-1.164,1.21q-11.206-.048-22.413,0c-.99,0-1.268-.354-1.265-1.29q.041-11.137.009-22.275",
    transform: "translate(-284.004 -0.159)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M142.58,4.748c.6.029,1.044.069,1.493.069,2.305,0,4.614.064,6.915-.036,1.259-.055,1.623.389,1.516,1.583-.1,1.084-.021,2.183-.021,3.414,1.393,0,2.627.037,3.859-.013.849-.034,1.145.289,1.109,1.13-.054,1.264-.014,2.533-.014,3.841,1.452,0,2.652.043,3.846-.015.864-.042,1.138.31,1.109,1.129-.043,1.229-.011,2.461-.011,3.757H167.2V13.5c0-3.86,0-3.826,3.875-3.746.965.02,1.167.4,1.13,1.241-.051,1.184-.013,2.372-.013,3.647H177.1c0-1.27.055-2.459-.017-3.642-.06-.993.332-1.3,1.281-1.242,1.173.066,2.352.016,3.551.016V4.958h-2.989c-1.821,0-1.822,0-1.822-1.761V.1H167.27c0,1.2-.048,2.386.015,3.567.05.926-.188,1.388-1.218,1.3a16.729,16.729,0,0,0-2.626,0c-.9.062-1.255-.259-1.213-1.175.055-1.223.014-2.451.014-3.779h-5.7q-6.362,0-12.725,0c-.57,0-1.265-.174-1.243.811.029,1.276.007,2.554.007,3.926",
    transform: "translate(-103.111 0)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M40.751,183.024v5.007H35.9v4.743c1.166,0,2.265.078,3.348-.02,1.236-.113,1.577.335,1.535,1.554-.093,2.746-.029,5.5-.029,8.393,1.453,0,2.732.026,4.009-.01.718-.02.988.254.968.97-.036,1.277-.01,2.555-.01,3.91h9.806v-4.926h4.822v-4.755c-2.886,0-5.689-.034-8.489.018-1.03.019-1.389-.342-1.352-1.363.062-1.7.017-3.41.017-5.115v-3.512h-4.8v-4.941h4.712v-4.971H45.853c-.081,1.619-.164,3.24-.256,5.017Z",
    transform: "translate(-25.962 -128.738)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M172.066,464.1h-4.8c0,1.25-.047,2.4.014,3.539.053.978-.338,1.29-1.288,1.27-2.442-.051-4.886.011-7.327-.047-.947-.023-1.335.238-1.267,1.239.08,1.175.019,2.36.019,3.669-1.433,0-2.671-.058-3.9.019-.967.06-1.174-.371-1.159-1.221.037-2.073.011-4.148.011-6.222v-2.289h-4.88v9.708c-1.476,0-2.718.024-3.958-.009-.7-.019-1.011.219-.977.955a26.214,26.214,0,0,1,0,2.9c-.055.852.253,1.115,1.1,1.113q13.688-.036,27.375,0c.957,0,1.147-.379,1.139-1.234-.037-4.055-.019-8.111-.028-12.167,0-.4-.046-.8-.073-1.228",
    transform: "translate(-103.092 -335.612)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M71.7,177.913h.044l0-.036h-.049c0,.013,0,.025,0,.038l0,0",
    transform: "translate(-51.851 -128.644)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M5.246,143.1H.517v29.3H5.229c0-2.9.036-5.7-.02-8.506-.019-.981.319-1.31,1.273-1.263,1.214.059,2.433.014,3.618.014v-4.916H5.3v-5.007c5.017,0,9.967,0,14.913,0q-.027-2.436-.049-4.875H5.246Z",
    transform: "translate(-0.374 -103.494)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M486.489,157.942h-4.807v9.687c1.2,0,2.348.061,3.482-.018,1.081-.076,1.457.278,1.44,1.4-.06,3.966-.026,7.934-.02,11.9,0,.49.041.98.065,1.525h4.69v-39.2h-4.851Z",
    transform: "translate(-348.362 -103.588)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M460.963,450.908h-4.957v-4.779h-9.663v4.755c1.339,0,2.534.028,3.727-.01.781-.025,1.074.3,1.054,1.063-.033,1.235-.009,2.472-.009,3.9a32.261,32.261,0,0,0,3.384-.023c1.338-.149,1.619.408,1.581,1.633-.084,2.7-.026,5.412-.026,8.184h4.887c0-1.338.027-2.574-.01-3.808-.023-.766.244-1.077,1.041-1.043,1.266.053,2.536.014,3.767.014V446.16h-4.777Z",
    transform: "translate(-322.804 -322.649)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M61.894,308.286c-2.7-.1-5.412-.03-8.19-.03v9.754c1.26,0,2.45.053,3.634-.017.951-.056,1.339.237,1.279,1.236-.074,1.219-.018,2.445-.018,3.688h4.809c0-2.58.012-5.016,0-7.453s-.027-2.425,2.332-2.425H73.2v-4.875H68.336v-4.81H63.548a31.545,31.545,0,0,0,.022,3.212c.14,1.335-.321,1.768-1.676,1.719",
    transform: "translate(-38.84 -219.393)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M308.485,449.819c.046.981-.357,1.306-1.309,1.255-1.174-.064-2.354-.015-3.549-.015v14.625h4.751v-4.82h4.839V446.192h-4.745c0,1.259-.042,2.445.013,3.627",
    transform: "translate(-219.589 -322.695)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M271.195,99.28c-1.172-.081-2.353-.019-3.576-.019v4.827c2.781,0,5.449.071,8.11-.03,1.355-.051,1.971.255,1.784,1.734a25.686,25.686,0,0,0-.025,3.169h4.74V99.333c-.477-.028-.88-.067-1.284-.072-3.585-.047-3.585-.045-3.585-3.641V89.456h-4.825c0,2.905-.041,5.711.021,8.515.023,1.054-.34,1.379-1.36,1.309",
    transform: "translate(-193.547 -64.696)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M426.327,290.32c-.766.012-1.077-.242-1.047-1.035.049-1.268.013-2.54.013-3.872h-4.9c0,1.17-.075,2.312.021,3.44.1,1.161-.312,1.511-1.466,1.479-2.746-.077-5.495-.025-8.285-.025v4.722a2.144,2.144,0,0,0,.489.148c6.029,0,12.059-.007,18.088.009.822,0,1.011-.4,1-1.113-.012-1.229.023-2.458.039-3.687-1.319-.027-2.639-.086-3.957-.065",
    transform: "translate(-297.001 -206.416)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M4.068,259.861c-1.135-.094-2.284-.021-3.5-.021v4.808h14.52v-4.809a31.723,31.723,0,0,0-3.346.024c-1.248.136-1.582-.3-1.541-1.523.092-2.7.029-5.414.029-8.191H5.367v1.45c0,2.305-.038,4.611.019,6.915.025,1-.236,1.435-1.318,1.346",
    transform: "translate(-0.412 -180.913)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M367.675,468.973c-1.071.076-1.362-.363-1.3-1.363.075-1.134.017-2.278.017-3.463H361.5c0,1.2-.079,2.3.021,3.388.112,1.2-.388,1.518-1.5,1.439-1.125-.081-2.26-.018-3.469-.018,0,3.123-.017,6.021.026,8.917,0,.3.355.838.568.849,1.4.077,2.816.04,4.329.04v-4.947H371.2v-4.859c-1.244,0-2.39-.063-3.525.018",
    transform: "translate(-257.868 -335.68)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M486.557,304.792c0,2.352-.061,4.705.026,7.053.043,1.141-.357,1.45-1.429,1.371-1.166-.086-2.343-.02-3.51-.02v4.829c1.393,0,2.635.033,3.874-.012.781-.028,1.071.261,1.044,1.042-.044,1.272-.012,2.547-.012,3.851h4.75V303.374H486.62c-.024.521-.061.969-.062,1.418",
    transform: "translate(-348.334 -219.406)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M249.755,450.942c1.194,0,2.338.076,3.466-.021,1.182-.1,1.487.354,1.456,1.484-.074,2.75-.024,5.5-.024,8.365h4.8V446.2h-9.7Z",
    transform: "translate(-180.628 -322.704)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 9.58,
    height: 9.631,
    transform: "translate(0.135 88.911)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M463.4,410.128h-.046l.039.04-.039-.039v.047h.046Z",
    transform: "translate(-335.107 -296.612)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M467.469,384.678c.358-.024.979-.472.985-.736.071-2.972.045-5.946.045-8.957h-4.978v9.727c1.317,0,2.637.053,3.948-.034",
    transform: "translate(-335.227 -271.196)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M445.817,485.059v6.173h4.812v-9.657c-.418-.027-.819-.072-1.22-.076-3.592-.04-3.592-.038-3.592,3.561",
    transform: "translate(-322.423 -348.224)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 4.729,
    height: 9.583,
    transform: "translate(123.508 54.342)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M481.583,303.276v-.041h-.037c0,.013,0,.026,0,.039Zm-.021-.023.006.007-.006-.007",
    transform: "translate(-348.263 -219.305)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M486.409,285.586h-4.726v4.885h4.726Z",
    transform: "translate(-348.362 -206.541)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 0.041,
    height: 0.044,
    transform: "translate(44.398 49.284)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M178.488,178.086l-.011.022h.022v-.044h-.024c0,.014,0,.029,0,.044l.011-.022",
    transform: "translate(-129.077 -128.779)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M165.3,160.9h-4.748v4.751h4.96c-.07-1.573-.14-3.147-.211-4.752",
    transform: "translate(-116.117 -116.364)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 4.709,
    height: 4.645,
    transform: "translate(44.498 9.977)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 4.743,
    height: 4.644,
    transform: "translate(93.861 5.044)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 4.636,
    height: 4.705,
    transform: "translate(79.107 14.917)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 4.656,
    height: 4.772,
    transform: "translate(138.307 108.625)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M90.088,159.623h0v0Z",
    transform: "translate(-65.153 -115.439)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M89.023,164.653h4.968c-.087-1.714-.17-3.334-.25-4.95q-2.208-.032-4.423-.07c-.1,1.659-.2,3.318-.3,5.02",
    transform: "translate(-64.383 -115.45)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M106.064,159.777h.039l0,0c0-.012,0-.025,0-.037l-.041,0c0,.014,0,.028,0,.042",
    transform: "translate(-76.706 -115.523)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 4.778,
    height: 4.63,
    transform: "translate(69.117 29.745)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M183.5,71.516h-4.594v4.958c1.52-.069,3.042-.136,4.594-.2Z",
    transform: "translate(-129.388 -51.722)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M178.784,89.432l.034.037v-.038h-.034",
    transform: "translate(-129.3 -64.678)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M71.514,160.135c0,.012,0,.023,0,.034h.034v-.036h-.034Z",
    transform: "translate(-51.72 -115.812)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_102",
    "data-name": "Trac\\xE9 102",
    d: "M90.086,159.623v0h0v0",
    transform: "translate(-65.151 -115.439)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M71.642,143.172c0,1.622,0,3.159,0,4.694l5.105-.142-.5-4.552Z",
    transform: "translate(-51.812 -103.545)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 4.66,
    height: 4.644,
    transform: "translate(88.954 0.091)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 4.637,
    height: 4.66,
    transform: "translate(84.009 9.992)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M107.512,218.874h4.68V214.2h-4.68Z",
    transform: "translate(-77.755 -154.91)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_105",
    "data-name": "Trac\\xE9 105",
    d: "M124.419,214.121h.028c0-.009,0-.019,0-.029h-.029Z",
    transform: "translate(-89.982 -154.835)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M183.155,111.936v-4.6h-4.712q0,2.3,0,4.6Z",
    transform: "translate(-129.053 -77.627)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M178.347,107.242v-.036h-.036c0,.012,0,.024,0,.035Z",
    transform: "translate(-128.957 -77.533)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 4.66,
    height: 4.599,
    transform: "translate(79.09 0.121)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 4.655,
    height: 4.75,
    transform: "translate(108.675 108.614)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M36.489,427.974c-1.022-.009-.939.614-.938,1.277q.007,6.084.009,12.169c0,.4.06.792.091,1.175H50.212v-14.45a1.815,1.815,0,0,0-.448-.141c-4.425-.01-8.85.006-13.275-.031",
    transform: "translate(-25.71 -309.519)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M35.548,49.985c0,.968.639.831,1.228.831q5.118,0,10.236-.011c1.044,0,2.088,0,3.2,0V36.193H35.557c0,4.68.011,9.236-.009,13.792",
    transform: "translate(-25.709 -26.175)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M442.252,50.684c.322,0,.913-.51.917-.789.058-4.55.041-9.1.041-13.838H428.6V50.72c4.644,0,9.15.017,13.654-.035",
    transform: "translate(-309.97 -26.077)",
    fill: "#dedede"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(142.112 354.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M42.444,0C35.1,7.553,32.29,17.461,32.314,23.784c0,15.5,10.561,23.6,4.168,34.76l-.768-.3c2.992-9.282-6.288-22.926-16.045-23.146C7.909,34.864.388,43.8.388,53.474c0,5.047,5.309,15.384,17.1,14.572C8.62,63.405,8.4,52.209,14.243,48.624c10.572-6.486,19.049,5.7,18.839,16.684,7.2-2.657,19.864-21.951,19.864-41.141,0-6.323-3.155-16.6-10.5-24.156",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M19.951,80.137c5.042-3.144,9.117-13.667,10.619-19.909C20.218,47.094,27.018,30.77,41.724,27.765,54.543,25.143,63.392,39,50.84,48.068c7.8,2.529,18.024-5.592,17.826-14.9-.28-12.786-10.56-19.666-22.425-17.125-11.934,2.483-22.553,18.1-27.327,32.8-3.109,9.56-3.609,20.513,1.036,31.3",
    transform: "translate(24.066 23.157)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_50",
    "data-name": "Groupe 50",
    transform: "translate(25.5 24.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M102.513,2476.313v-34.492H137",
    transform: "translate(-33.513 -2150.821)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113",
    "data-name": "Trac\\xE9 113",
    d: "M0,34.491V0H34.492",
    transform: "translate(254 472.18) rotate(180)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112",
    "data-name": "Trac\\xE9 112",
    d: "M0,34.491V0H34.492",
    transform: "translate(254 291) rotate(90)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M0,34.491V0H34.492",
    transform: "translate(69 472.179) rotate(-90)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_51",
    "data-name": "Groupe 51",
    transform: "translate(0 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 236,
    height: 56,
    transform: "translate(69 406)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_38",
    "data-name": "Ligne 38",
    x2: 236,
    transform: "translate(69 406)",
    fill: "none",
    stroke: "#ff9e17",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QRCode.97e64e44d138aa56b80de55ab1a263c1.svg";
export { ForwardRef as ReactComponent };